/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuietHours } from './QuietHours';
import {
    QuietHoursFromJSON,
    QuietHoursFromJSONTyped,
    QuietHoursToJSON,
    QuietHoursToJSONTyped,
} from './QuietHours';

/**
 * 
 * @export
 * @interface CategoryOverride
 */
export interface CategoryOverride {
    /**
     * 
     * @type {Array<string>}
     * @memberof CategoryOverride
     */
    channels?: Array<string>;
    /**
     * 
     * @type {QuietHours}
     * @memberof CategoryOverride
     */
    quietHours?: QuietHours;
}

/**
 * Check if a given object implements the CategoryOverride interface.
 */
export function instanceOfCategoryOverride(value: object): value is CategoryOverride {
    return true;
}

export function CategoryOverrideFromJSON(json: any): CategoryOverride {
    return CategoryOverrideFromJSONTyped(json, false);
}

export function CategoryOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'channels': json['channels'] == null ? undefined : json['channels'],
        'quietHours': json['quietHours'] == null ? undefined : QuietHoursFromJSON(json['quietHours']),
    };
}

export function CategoryOverrideToJSON(json: any): CategoryOverride {
    return CategoryOverrideToJSONTyped(json, false);
}

export function CategoryOverrideToJSONTyped(value?: CategoryOverride | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'channels': value['channels'],
        'quietHours': QuietHoursToJSON(value['quietHours']),
    };
}

